import { render, staticRenderFns } from "./questionFrom.vue?vue&type=template&id=24c3cca8&scoped=true"
import script from "./questionFrom.vue?vue&type=script&lang=js"
export * from "./questionFrom.vue?vue&type=script&lang=js"
import style0 from "./questionFrom.vue?vue&type=style&index=0&id=24c3cca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c3cca8",
  null
  
)

export default component.exports